const SORTABLE_FIELDS = {
  TEXT_SORTED: [
    'territories'
  ]
};

export const shouldSort = (fieldName) => {
  return SORTABLE_FIELDS.TEXT_SORTED.includes(fieldName);
};
